import * as React from "react";

import MuiAvatar from "@material-ui/core/Avatar";

import genRngHex from "../../utils/rng-hex";
import { Avatar } from "../organisms";

interface ProfileAvatarProps {
  img?: string;
  name: string;
  surname?: string;
  isOpenable?: boolean;
}

const ProfileAvatar = ({ img, name, surname }: ProfileAvatarProps) => {
  if (img && img !== "https://pic1.png") {
    return <Avatar photo={img} />;
  }

  const bgColor = genRngHex(name);
  const initials = name ? name.split(" ").map((word) => word.length && word[0].toUpperCase()) : "";
  const initialsSurname = surname ? surname.split(" ").map((word) => word.length && word[0].toUpperCase()) : "";

  return <MuiAvatar style={{ background: bgColor }}>{initials[0] + (initialsSurname[0] || "")}</MuiAvatar>;
};

export default ProfileAvatar;



// WEBPACK FOOTER //
// ./src/components/molecules/ProfileAvatar.tsx